export enum Direction { Up, Right, Down, Left }
export enum Keys {
  Up = 38,
  Right = 37,
  Left = 39,
  Down = 40,
  Space = 32,
  Return = 13
}